<template>
  <div>
    <el-card class="box-card">
       <div slot="header" class="clearfix">
        <span><i class="el-icon-bank-card"></i> Card</span>
       </div>


      <el-form :inline="true" :model="query" size="medium">
        <el-form-item label="Currency">
          <el-select v-model="query.currency" placeholder="Currenct" style="width:100px">
            <el-option value="" label="All"></el-option>
            <el-option value="gbp" label="GBP"></el-option>
            <el-option value="eur" label="EUR"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" :loading="loading" @click="getCardReport()">Query</el-button>
          <el-button type="success" icon="el-icon-download" @click="exportExcel()">Export</el-button>
        </el-form-item>
      </el-form>
          
      <data-tables v-loading="loading" :data="dataTable" border :page-size="10" :pagination-props="{ background: true, pageSizes: [5, 10, 20, 50, 100] }">

        <el-table-column prop="created_date" label="Date" header-align="center" align="center" fixed width="90"></el-table-column>
        <el-table-column prop="created_time" label="Time" header-align="center" align="center" fixed width="90"></el-table-column>
        <el-table-column prop="member_code" label="Member" header-align="center" align="center" fixed width="90"></el-table-column>
        <el-table-column prop="card_type" label="Card Type" header-align="center" align="center" width="110" sortable></el-table-column>
        <el-table-column prop="card_number" label="Card Number" header-align="center" align="center" width="180"></el-table-column>
        <el-table-column prop="card_token" label="Card Token" header-align="center" align="center" width="180"></el-table-column>
        <el-table-column prop="3dsecure" label="3D Secure" header-align="center" align="center" width="90"></el-table-column>
        <el-table-column prop="currency" label="Currency" header-align="center" align="center" width="110" sortable></el-table-column>
        <el-table-column prop="status" label="Status" header-align="center" align="center" width="120" sortable></el-table-column>
        <el-table-column prop="type" label="Type" header-align="center" align="center" width="90" sortable></el-table-column>
        <el-table-column prop="BankholderID" label="BankholderID" header-align="center" align="center" width="180"></el-table-column>
        <el-table-column prop="project_name" label="Project" header-align="center" align="center" width="200"></el-table-column>
        <el-table-column prop="customer_name" label="Customer" header-align="center" align="center" width="200"></el-table-column>
        <el-table-column prop="company_name" label="Company" header-align="center" align="center" width="200"></el-table-column>
        <el-table-column prop="rigion" label="Rigion" header-align="center" align="center" width="90"></el-table-column>
        <el-table-column prop="terminalID" label="TerminalID" header-align="center" align="center" width="200"></el-table-column>
        <el-table-column prop="user" label="Authoirse Account" header-align="center" align="center" width="150"></el-table-column>

      </data-tables>




    </el-card>
  </div>
</template>

<script>
import {getCard, getCardExcel } from '@/api/report'
export default {
  props:{
    project: String
  },
  watch: {
      project(val, old) {
        this.query.project_uid = val;
        this.getCardReport();
      }
  },
  data(){
    return {
      query:{
        project_uid: "",
        currency: ""
      },
      dataTable:[],
      loading: false
    }
  },
  methods:{
    getCardReport(){
      this.loading = true
      getCard(this.getQuery()).then(({result, data})=>{
        this.loading = false
        if(result){
          this.dataTable = data
        }
      })
    },
    getQuery(){
      this.query.project_uid = this.project;
      return this.query;
    },
    exportExcel(){
      getCardExcel(this.getQuery())
    }
  }
}
</script>

<style>

</style>